import { Box } from '@mui/material';
import { Suspense } from 'react';
import { DetailGroup } from '@pages/QuoteDetails/sidebarItems/summary/DetailGroup';
import { DetailItem, DetailItemProps } from '@pages/QuoteDetails/sidebarItems/summary/DetailItem';
import { RatingSummaryModal, TotalInsurableValueModal } from '@pages/QuoteDetails/sidebarItems/summary/modals';
import { ModalType } from '@pages/QuoteDetails/sidebarItems/summary/getQuoteSummaryData';
import { useQuoteSummaryHelper } from '@pages/QuoteDetails/sidebarItems/summary/useQuoteSummaryHelper';

export const QuoteDetailsPanel = () => {
  const { quoteId, quote, lastSuccessfulRating, isRatingModalOpen, isTIVModalOpen, setModalOpen, summaryData } =
    useQuoteSummaryHelper();

  const summaryDetails = [
    summaryData.quoteDetails,
    summaryData.customerDetails,
    summaryData.partnerAgent,
    summaryData.customerService,
  ];

  return (
    <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto', width: '100%' }}>
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
          overflowX: 'hidden',
          pr: 1,
          width: '100%', // Ensure content takes full available width
          maxWidth: '100%', // Prevent content from exceeding container width
        }}
      >
        {summaryDetails.map((group) => (
          <DetailGroup
            name={group.label}
            key={group.label}
            sx={{
              pl: '16px',
              // Ensure all sections, including Brokerage and Customer Details, use full width columns
              gridColumn: '1 / -1',
            }}
          >
            {group.fields.map((field: DetailItemProps) => (
              <DetailItem label={field.label} value={field.value} suffix={field.suffix} key={field.label} />
            ))}
          </DetailGroup>
        ))}
        <Suspense fallback={<Box sx={{ p: 2 }}>Loading details...</Box>}>
          {lastSuccessfulRating && isRatingModalOpen && (
            <RatingSummaryModal
              quoteId={quoteId}
              isOpen={isRatingModalOpen}
              onCloseModal={() => setModalOpen(ModalType.RatingSummaryModal, false)}
            />
          )}
          {isTIVModalOpen && (
            <TotalInsurableValueModal
              quoteId={quoteId}
              isOpen={isTIVModalOpen}
              policyNumber={quote?.policyNumber?.policyNumber}
              onCloseModal={() => setModalOpen(ModalType.TIVModal, false)}
            />
          )}
        </Suspense>
      </Box>
    </Box>
  );
};
